/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as manipulações de divisões
 * @author Bene Lemuel Dantas Gondim
 * @file orgao.divisaoReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */
import types from 'utils/actionTypes'
// Estado inicial da sessão no redux
const initialState = {
  divisoes: [],
  error: null,
  nomeFuncao: '',
  dados: {
    id: '',
    nome: '',
    sigla: '',
    descricao: '',
    regional: '',
  },
}

const divisoesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_DIVISOES: {
      return {
        ...state,
        divisoes: action.divisoes,
      }
    }

    default: {
      return state
    }
  }
}

export default divisoesReducer
